import { InjectionToken } from '@angular/core';
import { GridType } from '@data-access/grid-views';
import {
  DEFAULT_BASE_GRID_PROPS,
  DEFAULT_CHECKBOX_PROPS,
} from '@data-access/shared';
import { SubmittedDocumentsGrid } from '../types';

export const SDInitialState: SubmittedDocumentsGrid = {
  currentUrl: '',
  data: [],
  gridType: 'organizationFacilities' as GridType,
  views: [],
  workspaceId: null,
  workspaceIntId: null, 
  currentPageDocuments: [],
  pendingDocuments: [],
  documentTasks: [],
  filteredByTask: false,
  taskInstanceId: null,
  uploadedRequiredTaskIds: [],  
  navigateToRequiredDocuments: false, 
  ...DEFAULT_CHECKBOX_PROPS,
  ...DEFAULT_BASE_GRID_PROPS,
};

export const SUBMITTED_DOCUMENT_GRID_STATE =
  new InjectionToken<SubmittedDocumentsGrid>('Submitted Documents grid state', {
    factory: () => ({ ...SDInitialState }),
  });
